import { IndustryTemplate } from '@/components';
import { garageDoorContent } from '@/data/industries/garagedoor';

export function GarageDoorPage() {
  return <IndustryTemplate content={garageDoorContent} />;
}
